export { default as getCommonFormFieldProps } from './getCommonFormFieldProps';

export type { GetCommonFormFieldPropsFunction } from './getCommonFormFieldProps.type';
